import Seo from "@/components/Seo";
import Hero from "@/pages/home/components/Hero";
import Categories from "@/pages/home/components/Categories";
import HotStories from "@/pages/home/components/HotStories";
import FeaturedSpecial from "@/pages/home/components/FeaturedSpecial";
import Process from "@/pages/home/components/Process";
import Testimonials from "@/pages/home/components/Testimonials";
import Faq from "@/pages/home/components/Faq";
import Cta from "@/pages/home/components/Cta";
import { SITE } from "@/mocks/site";
import { FAQS } from "@/mocks/content";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE.fullName,
    url: SITE.url,
    inLanguage: "zh-CN",
    description: SITE.description,
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE.fullName,
    url: SITE.url,
    email: SITE.email,
    logo: `${SITE.url}/vite.svg`,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="幕外 · 小电影幕后花絮与片场故事全纪录"
        description="追完小电影正片还想挖幕后料？幕外收录小电影拍摄花絮、幕后故事、导演访谈、片场日记、制作特辑与创作过程，用番外视角补全每一部短片的创作细节。"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <Categories />
      <HotStories />
      <FeaturedSpecial />
      <Process />
      <Testimonials />
      <Faq />
      <Cta />
    </>
  );
}